{
  "Add": "Add",
  "AddCurrencyAdjustmentCode": "Add Currency Adjustment Code",
  "AddCurrencyAdjustmentCondition": "Add Currency Adjustment Condition",
  "AddCurrencyAdjustmentPercentage": "Add Currency Adjustment Percentage",
  "AddCurrencyAdjustmentConditionVariant": "Add Currency Adjustment Condition Variant",
  "AddDeliveryRoute": "Add Delivery Route",
  "AddDeliveryRouteAllocationUnit": "Add Delivery Route Allocation Unit",
  "AddFilter": "Add filter",
  "AddPrice": "Add price",
  "AddMarkupConditionMaterial": "Add Markup Condition Material",
  "AddMarkupPercentage": "Add Markup Percentage",
  "AddProductClassComponentUnit": "Add Product Class Component Unit",
  "AdvancedFilter": "Advanced filter",
  "Adjustment": "Adjustment",
  "AdjustmentType": "AdjustmentType (MV, PV, AVC, or Crewcab) ",
  "AdjustmentsSavedSuccessfully": "Adjustments Saved Successfully",
  "All": "All",
  "AllocateError": "Items could not be allocated",
  "Allocated": "Allocated",
  "AllocationCheck": "Are you sure you want to check the box!",
  "AllocatedCheckedScaniaUnit": "Component successfully allocated",
  "AllocatedCheckedScaniaUnitUnchecked": "Component checkbox unchecked!",
  "AllocatedSuccessfully": "Allocated {0} items successfully",
  "AllocateSelected": "Allocate selected",
  "AllocateConfirmation": "Are you sure you want to allocate <strong>{0} {1}</strong>?<br /><br /><div class=\"alert alert-danger\"><strong>This action cannot be undone!</strong></div>",
  "AllocateComponentConfirmationNotCompletedSelected": "<div class=\"alert alert-info\"><strong>PS: Components which the calculation is not completed will not be allocated</strong></div>",
  "AllocateProductConfirmationNotCompletedSelected": "<div class=\"alert alert-info\"><strong>PS: Products which are not fully allocated will not be allocated</strong></div>",
  "AllocationComponentType": "Allocation Component Type",
  "AllocationDeliveryRouteCode": "Allocation Delivery Route Code",
  "AllocationScaniaUnit": "Allocation Scania unit",
  "AllocationFrom": "Allocation From",
  "AllocationTo": "Allocation To",
  "AllocationStatus": "Allocation status",
  "AlreadyExistingConsumingPlanningAreaMapping": "This mapping already exists",
  "AlreadyExistingDeliveryRoute": "Delivery route with same code exists!",
  "AlreadyExistingDeliveryRouteAllocationUnit": "Delivery route allocation with same property code exists!",
  "AlreadyExistingConsumingPlanningAreaMappingValidFrom": "This mapping already exists with from date greater than or equals to selected date",
  "ARReceive": "ARReceive",
  "Ascending": "Ascending",
  "Axle": "Axle",
  "Back": "Back",
  "BaseUnit": "Base Unit",
  "BatteryVehicle": "Battery Vehicle",
  "BaseCost": "Base Cost",
  "Business": "Business",
  "ConvertedBaseCost": "Base Cost LC",
  "Cab": "Cab",
  "CalculationDetails": "Calculation details",
  "CalculationStatus": "Calculation Status",
  "Cancel": "Cancel",
  "ChangePriceOrDate": "Change price type to strategic or set future dates for manual price type",
  "Chassis": "Chassis",
  "ChassisBus": "Chassis Bus",
  "ChassisNumber": "Chassis number",
  "ChassisNumberNotFound": "Chassis number not found",
  "ChassisTruck": "Chassis Truck",
  "ChassisType": "Chassis type",
  "ClearFilterAndSort": "Clear filter and sorting",
  "CheckboxUncheckingConditionInformation": "These checkboxes will be unchecked at Day -2 before every Book Closure starts & again after Book Closure ends!",
  "Close": "Close",
  "Code": "Code",
  "CodeInUse": "Code cannot be deleted because it is linked to condition!",
  "CodeRequired": "Code Required",
  "Comment": "Comment",
  "Completed": "Completed",
  "Component": "Component",
  "component": "component",
  "component_s": "component(s)",
  "ComponentDescription": "Component description",
  "ComponentPartsList": "List of component parts",
  "ComponentUnitCodeRequired": "Component unit code is Required",
  "ComponentUnitRequired": "Component Unit is Required!",
  "ComponentTypeRequired": "Component Type is Required!",
  "ComponentId": "Component Id",
  "ComponentSpecificationList": "List of component specification",
  "ComponentUnit": "Component unit",
  "ComponentUnitShort": "CU",
  "ComponentUnitCode": "Component unit code",
  "ComponentUnitDescription": "Component unit description",
  "ComponentUnitDescriptionShort": "CU description",
  "ComponentType": "Component Type",
  "ComponentTypeId": "ComponentTypeId",
  "ConditionId": "Condition ID",
  "ConditionsCount": "No of conditions",
  "ConditionDescription": "Condition description",
  "Confirm": "Confirm",
  "ConsolidationProductClass": "Consolidation Product Class",
  "ConsolidationFrom": "Consolidation From",
  "ConsolidationTo": "Consolidation To",
  "Country": "Country",
  "CreatedOn": "CreatedOn",
  "CountryCode": "Country code",
  "CurrencyCode": "Currency",
  "CurrencyRate": "Currency Rate",
  "ConsumingPlanningArea": "CPA",
  "ConsumingPlanningAreaMappingAdd": "Add consuming planning area mapping",
  "ConsumingPlanningAreaMappingAddedSuccessfully": "Consuming planning area mapping added successfully",
  "CurrencyAdjustmentCode": "Currency Adjustment Code",
  "CurrencyAdjustmentCodeDeleteConfirm": "Are you sure you want to delete currency adjustment code {0} ?",
  "CurrencyAdjustmentCodeExist": "Currency Adjustment Code exist!",
  "CurrencyAdjustmentCodeList": "Currency Adjustments Code List",
  "CurrencyAdjustmentPercentageDeleteConfirm": "Are you sure you want to delete percentage {0} ?",
  "CurrencyAdjustmentPercentageExist": "Percentage for selected month already exist!",
  "CurrencyAdjustmentPercentageList": "Currency Adjustments Percentage List",
  "CurrencyAdjustmentConditionList": "Currency Adjustments Condition List",
  "CurrencyAdjustmentConditionExist": "Condition already exist for same market & product class!",
  "CurrencyAdjustmentConditionVariantDeleteConfirm": "Are you sure you want to delete condition variant {0}-{1} ?",
  "Customer": "Customer",
  "CustomRemarks": "Custom remarks",
  "DefaultCurrency": "SEK",
  "Delete": "Delete",
  "DeleteConfirmation": "Delete confirmation",
  "DeletedSuccessfully": "Deleted successfully",
  "DeliveryRoute": "Delivery Route",
  "DeliveryRouteSavedSuccessfully": "Delivery route saved successfully",
  "DeliveryRouteAllocationUnitAddedSuccessfully": "Delivery route allocation unit added successfully",
  "DeliveryRouteCode": "Delivery Route Code",
  "DeliveryRouteCodeRequired": "Code is required!",
  "DeliveryRouteDescriptionRequired": "Description is required!",
  "DeliveryRouteList": "Delivery Route List",
  "DeliveryRouteIsRequired": "Delivery route is required!",
  "Descending": "Descending",
  "Description": "Description",
  "DuplicateMarkupConditionMaterialEntry": "Combination of MarkupConditionId and MaterialId and the selected dates overlaps with an existing Markup Condition Material in the list",
  "EditDeliveryRoute": "Edit Delivery Route",
  "ElectricPropVehicle": "Electric Propulsion Vehicle",
  "Email": "Email",
  "Empty": "Empty",
  "EngineIM": "EngineIM",
  "EngineVehicle": "Engine Vehicle",
  "Error": "Error",
  "ErrorMessage": "Error Message",
  "ErrorOccured": "Unexpected error occured!",
  "ExecutionDate": "Execution date",
  "ExportError": "An error occurred while exporting list",
  "ExportToExcel": "Export to Excel",
  "ExportingList": "Exporting list...",
  "FaultCategory": "Category",
  "FFU": "FFU",
  "FFULong": "Fit for use",
  "FileName": "File Name",
  "FinalAssembly": "Final assembly",
  "FinalAssemblyUnit": "Final assembly unit",
  "FinishedComponentsSearch": "Finished Components Search",
  "FinishedProductsPageTitle": "List of finished products",
  "FinishedSimulationProductsTitle": "List of Simulation products",
  "FitForUseNumber": "Fit for use n°",
  "FlowErrors": "Flow errors",
  "FlowErrorPageTitle": "List of flow errors",
  "FlowStartFrom": "Flow step from",
  "FlowStartTo": "Flow step to",
  "FlowStep": "Flow step",
  "From": "From",
  "FutureStrategicPricesCannotBeUpdated": "Future strategic prices cannot be updated, delete the price and add a new one with the required dates",
  "GearboxExternal": "Gearbox External",
  "GearboxVehicle": "Gearbox Vehicle",
  "GosParts": "GOS Parts",
  "Id": "Id",
  "IsDeliveryValue": "Is Delivery Value",
  "IsMarkUpValue": "Is MarkUp Value",
  "Info": "Information",
  "IpoId": "IpoId",
  "ImportedPriceListDataSavedSuccessfully": "Price List Data Saved Successfully!",
  "ImportedPriceListDataValidatedSuccessfully": "Price List Data Validated Successfully!",
  "ImportedPriceListDataValidationError": "Price List Data has validation errors!",
  "ImportedPriceListDataSavingFailed": "Price List Data Saving Failed",
  "InvalidComment": "Invalid comment",
  "InvalidComponentType": "Invalid component type selected",
  "InvalidComponentUnitCode": "Invalid component unit code. Code must be an integer and cannot begin with 0",
  "InvalidConsumingPlanningArea": "Invalid Consuming planning area",
  "InvalidCSV": "invalid csv format",
  "InvalidConsumingPlanningAreaMapping": "Mapping to or Mapping from is invalid",
  "InvalidDates": "Invalid dates selected",
  "InvalidProductClass": "Invalid product class selected",
  "InvalidPrice": "Invalid price",
  "InvalidPriceType": "Invalid Price Type",
  "InvalidPIOrChassisNumberOrSerialNo": "Please type a Product individual number/Chassis number/Serial number that is at least 5 characters long",
  "InvalidPartNumber": "Invalid part number",
  "InvoicedAmount": "Invoiced Amount",
  "InvoiceDate": "Invoice date",
  "InvoiceDateRemoved": "Invoice Date Removed Successfully!",
  "InvoiceFrom": "Invoice From",
  "InvoiceTo": "Invoice To",
  "Item_s": "item(s)",
  "ItemSelected": "Item(s) selected",
  "KnrNumber": "KNR Number",
  "KnrNumberNotFound": "KNR number not found",
  "List": "List",
  "LastModifiedBy": "Last Modified By",
  "ManualInvoice": "Manual invoice",
  "ManualInvoiceConfirmation": "Are you sure you want to manual invoice <strong>{0} products?</strong><br /><br /><div class=\"alert alert-danger\"><strong>This action cannot be undone!</strong></div>",
  "ManualPrice": "Manual price",
  "ManualReceive": "ManualReceive",
  "Market": "Market",
  "MarketRequired": "Market is required!",
  "MarkupConditionMaterial": "Markup Condition Material",
  "MarkupConditionMaterialList": "Markup Condition Material List",
  "MarkupConditionMaterialExist": "Markup Condition Material already exist!",
  "MarkupCondition": "Markup Condition",
  "MarkupConditionRequired": "Markup condition required",
  "MarkupPercentageList": "Markup Percentage List",
  "MarkupPercentageExist": "Markup Percentage already exist!",
  "MaterialCode": "Material Code",
  "MaterialCodeRequired": "Material Code is required!",
  "MaximumEntriesAllowedForInvoicing": "Maximum 500 Manual Invoicing are allowed!",
  "MaximumEntriesAllowedForAdjustment": "Maximum 500 Manual Adjustment are allowed!",
  "MaterialCount": "Parts count",
  "MaterialInformation": "Material information",
  "MaterialNumber": "Part number",
  "MaterialName": "Material Name",
  "MaterialPageTitle": "Part list",
  "MaterialPeriod": "Part period",
  "MaterialPriceDeleteConfirmation": "Are you sure you want to delete {materialPriceType} price for part {materialNumber} valid from {validFrom} to {validTo}",
  "MaterialPrices": "Material prices",
  "Materials": "Parts",
  "MaterialType": "Part type",
  "MaterialValue": "Material value",
  "MaterialNumberNotMatchedWithMarkupCondition": "Material number not matched with markupCondition please select the right markup condition",
  "Message": "Message",
  "MissingSimInfo": "This report shows part numbers that has been in a simulation since August 2026 and still miss material prices",
  "ModifiedBy": "Modified by",
  "ModifiedOn": "Modified on",
  "ModifierComments": "Modifier comments",
  "MonthAndYear": "Month and year",
  "Month": "Month",
  "MonthsCSV": "January,February,March,April,May,June,July,August,September,October,November,December",
  "MoveToStock": "Move to stock",
  "MoveToStockConfirmation": "Are you sure you want to move <strong>{0} {1}</strong> to stock?",
  "MoveToStockError": "Items could not be moved to stock",
  "MovedToStockSuccessfully": "Moved {0} items to stock successfully",
  "Name": "Name",
  "NegativePrice": "Negative prices are not allowed",
  "No": "No",
  "NoComponentsSelected": "No components selected!",
  "NoConsumingPlanningAreaSelected": "no Consuming planning area selected!",
  "NoDataFound": "No data found",
  "NoProductsSelected": "No products selected!",
  "None": "None",
  "NoPastManualPrice": "Past manual prices are not allowed",
  "NoSort": "No sorting",
  "NotAllocated": "No items were allocated",
  "NotCompleted": "Not completed",
  "NotMovedToStock": "No items were moved to stock",
  "OK": "OK",
  "OnlyStrategicPricesCanBeUpdated": "Only startegic prices can be updated",
  "OutOfRangePrice": "Price is outside of the allowed range",
  "OverlappingDates": "Invalid date range. Dates conflict with an existing price",
  "Painted": "Painted",
  "Part": "Part",
  "PartPeriod": "Part period",
  "PartNumberRequired": "Part number required",
  "PartDescription": "Part Description",
  "PasteCSVLines": "Please paste csv lines in this format",
  "Percentage": "Percentage",
  "PercentageRequired": "Percentage is required",
  "PopId": "PopId",
  "Price": "Price",
  "PricedUnitOfMeasurement": "Priced unit of measurement",
  "PriceAddedSuccessfully": "Price is successfully added",
  "PriceInformationBox": "Standard price is the price from the source systems, it can be overwritten by the strategic price.<br />Manual price is only considered in case no price from source system or strategic price is defined.<br />Strategic prices has precedence over other prices and if set the system will always consider that price.",
  "PricePerUnit": "Price per unit",
  "PriceTypeInfo": "<ul><li>Re-calculations will use the prices valid on the respective day.</li><li>All newly updated prices will become effective starting the day after their update.</li><li>Excel export will include only prices that are valid</li></ul>",
  "PriceType": "Price type",
  "Print": "Print",
  "PreviewFileOnly": "Preview file only",
  "PreviewFileCreatedSuccessfully": "Preview file for {0} items created successfully",
  "Produced": "Produced",
  "ProducedFrom": "Produced from",
  "ProducedFromRequired": "Produced-from date required",
  "producedFromToCorrect": "Produced-to-date should not be lower than produced-from-date!",
  "ProducedTo": "Produced up to",
  "ProducedToRequired": "Produced-to date required",
  "ProductClass": "Product class",
  "ProductClassComponentUnitList": "Product Class Component Unit List",
  "ProductClassComponentUnitInformationBox": "If a new Component Unit <u>Code</u> is entered, a Component Unit is created and added to the database.<br />Any newly added ComponentUnit will be labeled as a top component unit.<br />Component Unit Description is optional and will overwrite the previous description for that unit.<br />Checking multiple Product Classes will create an entry for each selected class. Component Unit Code and Component Type will be the same for each entry.",
  "ProductClassRequired": "Product class is required!",
  "ProductIndividual": "Product individual",
  "ProductIndividualNumber": "Product individual n°",
  "ProductIndividualOrChassisNumberNotFound": "Product individual number or Chassis number not found",
  "ProductIndividualNumberNotFound": "Product individual number not found",
  "ProductionDate": "Production date",
  "ProductionPriceList": "Production Price List",
  "ProductionValue": "Production value",
  "ProductionValueCode": "Production Value Code",
  "ProductionValueCodeRequired": "Production Value Code is required!",
  "product_s": "product(s)",
  "PropertyCode": "Property Code",
  "PropertyCodeIsRequired": "Property code is required!",
  "PvaTotal": "Production Value Total",
  "PurchaserCode": "Purchaser code",
  "Quantity": "Quantity",
  "Recalculate": "Recalculate {0}",
  "RecalculateConfirmation": "Are you sure you want to recalculate <strong>{0} {1}</strong>?",
  "RecalculationFailed": "Recalculation failed",
  "RecalculationNotStarted": "Recalculation not triggered for any components",
  "RecalculationStarted": "Recalculation started for {0} {1}",
  "RecordAlreadyExistForSpecifiedInterval": "Record already exist for specified interval",
  "RecordAlreadyExist": "Record already exists",
  "RemoveButtonNotLoading": "The button is not visible as it may have flow errors or either components not fully allocated!",
  "RemoveInvoiceDate": "Please Enter Reason for Removal!",
  "RemovedInvoicedatesTitle": "List of Removed InvoiceDates",
  "ReasonOfRemoval": "Reason of Removal",
  "ReferenceNumber": "Reference number",
  "RecalculateMarkup": "Recalculate product(s)",
  "RequiredFieldError": "You must enter a value",
  "RequiredRow": "select atleast one valid row",
  "Save": "Save",
  "SaveConfirmation": "Are you sure you want to save?",
  "SavedSuccessfully": "Saved Successfully",
  "ScaniaUnit": "Scania unit",
  "ScaniaUnitAllocation": "Scania unit allocation",
  "ScaniaUnitAllocationIsRequired": "Scania unit allocation is required!",
  "ScaniaUnitConsolidation": "Scania unit consolidation",
  "ScaniaUnitConsolidationIsRequired": "Scania unit consolidation is required!",
  "ScaniaUnitIsRequired": "Scania unit is required!",
  "Search": "Search",
  "SelectAction": "Select Action",
  "SelectComponent": "Please select component(s)",
  "SelectProduct": "Please select product(s)",
  "SelectPriceType": "Select a price type",
  "SelectToFilter": "Select to filter",
  "SerialNumber": "Serial number",
  "SerialNumberNotFound": "Serial number not found",
  "SetComment": "Add comment and try again",
  "SetFromDate": "Select from date and try again",
  "SetFromConsumingPlanningArea": "Add from Consuming planning area and try again",
  "SetToConsumingPlanningArea": "Add to Consuming planning area and try again",
  "SetPrice": "Add price and try again",
  "ShowZeroQuantityParts": "Show parts with 0 quantity",
  "ShowValidCodes": "Show only valid codes",
  "ShowValidConditions": "Show only valid conditions",
  "showOnlyValidMarkupConditionMaterials": "Show only valid markup condition materials",
  "ShowValidMarkupPercentages": "Show valid markup percentages",
  "SimProdNumber": "Sim No.",
  "StructMarketCOReleaseTime": "CO Release Time",
  "Status": "Status",
  "SportMessage": "Sport Message",
  "Spare": "Spare",
  "SpecialOrderNumber": "Special order n°",
  "Specification": "Specification",
  "SpecificationCount": "Specification count",
  "Stock": "Stock",
  "StrategicPrice": "Strategic price",
  "Success": "Success",
  "Summary": "Summary",
  "SideMemberUpdate": "Side members updated successfully",
  "SideMemberUpdateError": "No SideMember data available for given chassis",
  "System": "System",
  "TimePeriod": "Time period",
  "To": "To",
  "ToDateGreaterThanFromDate": "Valid-to-date should not be lower than valid-from-date!",
  "ToDateShouldBeTomorrowOrLater": "Valid-to-date should not be lower than the current date!",
  "ToDateShouldBeEqualOrGreaterthanToday": " Valid to date should be equal or greater than current date!",
  "TotalItems": "Total {0} items",
  "TotalPrice": "Total price",
  "TotalValue": "Total value",
  "TotalMaterialValue": "Total Material Value",
  "TotalProductionValue": "Total Production Value",
  "TotalMarkupValue": "Total Markup Value",
  "TotalCurrencyValue": "Total Currency Value",
  "Type": "Type",
  "TypeToFilter": "Type to filter",
  "TotalInvoiceReceived": "Total Invoice Received",
  "UniqueDesign": "Unique Design",
  "UniqueDesignNumber": "Unique design n°",
  "Units": "units",
  "UserId": "User",
  "Update": "Update",
  "UpdatedBy": "UpdatedBy",
  "UpdatedOn": "UpdatedOn",
  "UpdateConfirmation": "Update confirmation",
  "UpdateSuccessfully": "Update successfully",
  "UserAuthorizationCheck": "Checking user rights...",
  "UserAuthenticated": "User authenticated...",
  "UserInformation": "User information",
  "UserNotAuthorizedError": "ERROR: User not authorized to use Calsium",
  "Username": "Username",
  "Logout": "Logout",
  "Value": "Value",
  "Validate": "Validate",
  "ValidDateFromRequired": "Valid date from required",
  "ValidFromValidToCorrect": "Valid-to-date should not be lower than valid-from-date!",
  "ValidFrom": "Valid from",
  "ValidTo": "Valid to",
  "ValidPercentage": "Percentage should be between 0 to 100",
  "Variant": "Variant(s)",
  "VariantClass": "Variant Class",
  "VariantCodes": "Variant codes",
  "VariantFamily": "Variant Family",
  "VariantFamilyRequired": "Variant Family is required!",
  "VariantFamilyDescription": "Variant Family Description",
  "VariantOption": "Variant Option",
  "VariantOptionRequired": "Variant Option is required!",
  "VariantOptionDescription": "Variant Option Description",
  "ViewAllocationDetails": "View allocation details",
  "ViewData": "View Data",
  "Volume": "Volume",
  "WeightInGrams": "Weight (in grams)",
  "WriteCSV": "write csv lines here",
  "Yes": "Yes",
  "InvoiceAmount": "Invoice amount",
  "ResponsiblityCode": "Responsibility Code",
  "ManualInvoicesSavedSuccessfully": "Manual invoices Saved Successfully",
  "InvoiceDateFormat": "yyyy-mm-dd",
  "WidgetError": "An error occurred while getting total",
  "Deallocate": "Deallocate {0}",
  "DeallocationConfirmation": "Are you sure you want to Deallocate <strong>{0} {1}</strong>?",
  "DeallocationFailed": "Deallocation failed",
  "DeallocationNotStarted": "Deallocation is not possible due to Final Assembly",
  "DeallocationStarted": "Deallocation started for {0} {1}",
  "DeallocationSuccessfully": "Deallocated {0} items successfully",
  "DeallocationFANotStarted": "Deallocation is not possible due to Consolidation",
  "Condition": "Condition",
  "seuPrice": "SEU Price",
  "seuPriceType": "SEU Price Type",
  "seuComments": "SEU Comments",
  "slaLocal": "SLA Local",
  "slaLocalPriceType": "SLA Local Type",
  "slaLocalComments": "SLA Local Comments",
  "slaExport": "SLA Export",
  "slaExportPriceType": "SLA Export Type",
  "slaExportComments": "SLA Export Comments",
  "SlaType": "SLA Type",
  "SEK": "kr",
  "BRL": "R$",
  "Simulation": "Simulation",
  "IsSimulation": "Is simulation",
  "MessageResponsibilityNote": "Responsibility code should be 0001 for trucks, 2000 for IM (Power Solutions) and for bus, please use the appropriate",
  "BusResponsibilityCode": "Bus Responsibility Codes",
  "DimensionCode": "Dimension Code",
  "NoteManualInvoicing": "to define correct bus type in KSV. For DGE (Gearbox External) use 0000. For SLA Chassis, system will accept only 2 invoices.",
  "InvoiceStatus": "Invoice Status",
  "Responsible": "Meco"
}
